import { ReactElement, ReactNode } from 'react';

export interface Term {
  header: ReactNode;
  value: ReactNode;
}

interface Props {
  inputs: Term[];
  result: Term;
  separator?: ReactNode;
  className?: string;
}

function TermBlock({ term, isResult }: { term: Term; isResult?: boolean }): ReactElement {
  return (
    <div className="cr-flex cr-flex-col cr-min-w-[6rem]">
      <div className="cr-text-xs cr-text-gray-500 cr-mb-1 cr-pb-1 cr-border-b cr-border-gray-200">
        {term.header}
      </div>
      <div
        className={`cr-text-sm cr-font-mono ${
          isResult ? 'cr-font-bold cr-text-blue-900' : 'cr-text-gray-800'
        }`}
      >
        {term.value}
      </div>
    </div>
  );
}

export default function FormulaRow({ inputs, result, separator = '=', className = '' }: Props): ReactElement {
  return (
    <div className={`cr-flex cr-items-stretch cr-gap-4 cr-flex-wrap ${className}`}>
      {inputs.map((t, i) => (
        <TermBlock key={i} term={t} />
      ))}
      <div className="cr-flex cr-items-end cr-text-xl cr-text-gray-400 cr-pb-1">{separator}</div>
      <TermBlock term={result} isResult />
    </div>
  );
}
